if (typeof window !== "undefined" && !window.global) {
  window.global = typeof global === "undefined" ? window : global;
}
//# sourceMappingURL=polyfills.js.map